// Liste de pays/territoires utilisée par le sélecteur de pays dans les checkouts
// et le profil utilisateur. Source initiale : dataset "curiexplore-pays" du
// Ministère de l'Enseignement supérieur (216 pays étrangers), enrichie avec
// les DROM-COM français manquants afin de couvrir la clientèle d'ovlm97.fr
// (Martinique et Antilles).
export const COUNTRIES = [
  'Afghanistan',
  'Afrique du Sud',
  'Albanie',
  'Algérie',
  'Allemagne',
  'Andorre',
  'Angola',
  'Antigua-et-Barbuda',
  'Arabie Saoudite',
  'Argentine',
  'Arménie',
  'Aruba',
  'Australie',
  'Autriche',
  'Azerbaïdjan',
  'Bahamas',
  'Bahreïn',
  'Bangladesh',
  'Barbade',
  'Belgique',
  'Belize',
  'Bénin',
  'Bermudes',
  'Bhoutan',
  'Biélorussie',
  'Birmanie',
  'Bolivie',
  'Bosnie-Herzégovine',
  'Botswana',
  'Brésil',
  'Brunei',
  'Bulgarie',
  'Burkina Faso',
  'Burundi',
  'Cambodge',
  'Cameroun',
  'Canada',
  'Cap Vert',
  'Chili',
  'Chine',
  'Chypre',
  'Colombie',
  'Comores',
  'Congo',
  'Congo (Rép. dém.)',
  'Corée du Nord',
  'Corée du Sud',
  'Costa Rica',
  "Côte d'Ivoire",
  'Croatie',
  'Cuba',
  'Curaçao',
  'Danemark',
  'Djibouti',
  'Dominique',
  'Égypte',
  'Émirats arabes unis',
  'Équateur',
  'Érythrée',
  'Espagne',
  'Estonie',
  'Eswatini',
  'États-Unis',
  'Éthiopie',
  'Fidji',
  'Finlande',
  'France',
  'Gabon',
  'Gambie',
  'Géorgie',
  'Ghana',
  'Gibraltar',
  'Grèce',
  'Grenade',
  'Groenland',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinée',
  'Guinée-Bissau',
  'Guinée-Équatoriale',
  'Guyana',
  'Guyane française',
  'Haïti',
  'Honduras',
  'Hong Kong (Chine)',
  'Hongrie',
  'Île de Man',
  'Ile Maurice',
  'Îles Caïmans',
  'Îles Féroé',
  'Îles Mariannes du Nord',
  'Îles Marshall',
  'Îles Salomon',
  'Îles Turques-et-Caïques',
  'Îles Vierges britanniques',
  'Inde',
  'Indonésie',
  'Irak',
  'Iran',
  'Irlande',
  'Islande',
  'Israël',
  'Italie',
  'Jamaïque',
  'Japon',
  'Jordanie',
  'Kazakhstan',
  'Kenya',
  'Kirghizistan',
  'Kiribati',
  'Kosovo',
  'Koweït',
  'Laos',
  'La Réunion',
  'Lesotho',
  'Lettonie',
  'Liban',
  'Liberia',
  'Libye',
  'Liechtenstein',
  'Lituanie',
  'Luxembourg',
  'Macao (Chine)',
  'Macédoine du Nord',
  'Madagascar',
  'Malaisie',
  'Malawi',
  'Maldives',
  'Mali',
  'Malte',
  'Maroc',
  'Martinique',
  'Mauritanie',
  'Mayotte',
  'Mexique',
  'Micronésie',
  'Moldavie',
  'Monaco',
  'Mongolie',
  'Monténégro',
  'Mozambique',
  'Namibie',
  'Nauru',
  'Népal',
  'Nicaragua',
  'Niger',
  'Nigéria',
  'Norvège',
  'Nouvelle-Calédonie',
  'Nouvelle-Zélande',
  'Oman',
  'Ouzbékistan',
  'Pakistan',
  'Palaos',
  'Panama',
  'Papouasie-Nouvelle-Guinée',
  'Paraguay',
  'Pays-Bas',
  'Pérou',
  'Philippines',
  'Pologne',
  'Polynésie française',
  'Porto Rico',
  'Portugal',
  'Qatar',
  'Québec',
  'République centrafricaine',
  'République dominicaine',
  'République tchèque',
  'Roumanie',
  'Royaume-Uni',
  'Russie',
  'Rwanda',
  'Saint-Barthélemy',
  'Saint-Christophe-et-Niévès',
  'Saint-Marin',
  'Saint Martin (partie néerlandaise)',
  'Saint-Martin (partie française)',
  'Saint-Pierre-et-Miquelon',
  'Saint-Vincent-et-les-Grenadines',
  'Sainte-Lucie',
  'Salvador',
  'Samoa',
  'Samoa américaines',
  'Sao Tomé-et-Principe',
  'Sénégal',
  'Serbie',
  'Seychelles',
  'Sierra Leone',
  'Singapour',
  'Slovaquie',
  'Slovénie',
  'Somalie',
  'Soudan',
  'Soudan du Sud',
  'Sri Lanka',
  'Suède',
  'Suisse',
  'Suriname',
  'Syrie',
  'Tadjikistan',
  'Taïwan',
  'Tanzanie',
  'Tchad',
  'Territoires palestiniens',
  'Thaïlande',
  'Timor oriental',
  'Togo',
  'Tonga',
  'Trinité et Tobago',
  'Tunisie',
  'Turkménistan',
  'Turquie',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'Uruguay',
  'Vanuatu',
  'Vatican',
  'Venezuela',
  'Viêt Nam',
  'Wallis-et-Futuna',
  'Yémen',
  'Zambie',
  'Zimbabwe',
];

const normalize = (str) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const INDEXED = COUNTRIES.map((name) => ({ name, norm: normalize(name) }));

export const searchCountries = (query, limit = 10) => {
  if (!query || !query.trim()) {
    return INDEXED.slice(0, limit).map(({ name }) => ({ name_fr: name }));
  }
  const q = normalize(query.trim());
  return INDEXED
    .filter(({ norm }) => norm.includes(q))
    .sort((a, b) => {
      const aStarts = a.norm.startsWith(q);
      const bStarts = b.norm.startsWith(q);
      if (aStarts !== bStarts) return aStarts ? -1 : 1;
      return a.name.localeCompare(b.name, 'fr');
    })
    .slice(0, limit)
    .map(({ name }) => ({ name_fr: name }));
};
